"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _iconsReact = require("../../icons-react");
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:

// Icons:

// Types

// Constants

var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    className: className
  }, children);
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Label__StyledWrapper",
  componentId: "sc-uibqxw-0"
})(["display:flex;height:22px;margin-bottom:4px;max-width:100%;&:hover{cursor:default;}"]);
var Label = function Label(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    title = props.title,
    description = props.description,
    _props$style = props.style,
    style = _props$style === void 0 ? 1 : _props$style,
    iconComponent = props.iconComponent,
    isSmall = props.isSmall;
  var labelRef = (0, _react.useRef)(null);
  var textRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOverflow = _useState2[0],
    setOverflow = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    var _labelRef$current, _textRef$current;
    var labelRight = labelRef === null || labelRef === void 0 || (_labelRef$current = labelRef.current) === null || _labelRef$current === void 0 ? void 0 : _labelRef$current.getBoundingClientRect().right;
    var textRight = textRef === null || textRef === void 0 || (_textRef$current = textRef.current) === null || _textRef$current === void 0 ? void 0 : _textRef$current.getBoundingClientRect().right;
    setOverflow(Number(labelRight) < Number(textRight) + 8);
  }, []);
  var Container = description !== null && description !== void 0 && description.trim() ? StyledBubble : StyledContainer;
  var _STYLES$style = _constants.STYLES[style],
    styleString = _STYLES$style.styleString,
    tooltipColor = _STYLES$style.tooltipColor;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    text: description,
    isSmall: isSmall
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    ref: labelRef,
    styleString: styleString,
    isOverflow: isOverflow
  }, iconComponent, style === 999 ? /*#__PURE__*/_react["default"].createElement(_iconsReact.Done, {
    width: 16,
    style: {
      marginRight: 3
    }
  }) : null, /*#__PURE__*/_react["default"].createElement("span", {
    ref: textRef
  }, title), description ? /*#__PURE__*/_react["default"].createElement(StyledQuestionCircle, {
    tooltipColor: tooltipColor
  }) : null));
};
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "Label__StyledLabel",
  componentId: "sc-uibqxw-1"
})(["display:flex;border-radius:5px;white-space:nowrap;width:fit-content;flex-wrap:nowrap;max-width:100%;box-sizing:border-box;height:22px;padding:0px 6px;margin-right:4px;align-items:center;", " svg{min-width:14px;}", ""], function (_ref2) {
  var isOverflow = _ref2.isOverflow,
    isSmall = _ref2.isSmall;
  return (isOverflow || isSmall) && "  overflow: hidden;\n\n    > span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin: auto;\n    }";
}, function (_ref3) {
  var styleString = _ref3.styleString;
  return styleString;
});
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "Label__StyledBubble",
  componentId: "sc-uibqxw-2"
})(["display:flex;max-width:", ";align-self:self-start;height:22px;margin-bottom:4px;margin-right:4px;> div{max-width:100%;overflow:hidden;}&:hover{cursor:default;}"], function (_ref4) {
  var isSmall = _ref4.isSmall;
  return isSmall ? '100%' : 'fit-content';
});
var StyledQuestionCircle = (0, _styledComponents["default"])(_iconsReact.QuestionCircle).withConfig({
  displayName: "Label__StyledQuestionCircle",
  componentId: "sc-uibqxw-3"
})(["width:14px;height:14px;margin-left:4px;stroke:none;margin-top:1px;circle{stroke:", ";}path{fill:", ";}"], function (_ref5) {
  var tooltipColor = _ref5.tooltipColor;
  return tooltipColor;
}, function (_ref6) {
  var tooltipColor = _ref6.tooltipColor;
  return tooltipColor;
});
var _default = exports["default"] = Label;